// 基础信息
export default [
    {
        path: '/baseinfo',
        redirect: '/baseinfo/brand',
    },

    // 品牌
    {
        path: '/baseinfo/brand',
        name: 'baseinfo-brand',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/brand/Index.vue'),
        meta: {title: '品牌管理'},
    },
    {
        path: '/baseinfo/brand/add',
        name: 'baseinfo-brand-add',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/brand/Add.vue'),
        meta: {title: '品牌管理'},
    },
    {
        path: '/baseinfo/brand/edit/:id',
        name: 'baseinfo-brand-edit',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/brand/Edit.vue'),
        meta: {title: '品牌管理'},
    },
    {
        path: '/baseinfo/brand/sub/:id',
        name: 'baseinfo-brand-sub',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/brand/subbrand/Index.vue'),
        meta: {title: '品牌管理'},
    },
    {
        path: '/baseinfo/brand/auth/:id',
        name: 'baseinfo-brand-auth',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/brand/authorize/Index.vue'),
        meta: {title: '品牌授权'},
    },

    // 属性和过滤项
    {
        path: '/baseinfo/property',
        name: 'baseinfo-property',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/property/Index.vue'),
        meta: {title: '属性管理'},
    },
    {
        path: '/baseinfo/property/add',
        name: 'baseinfo-property-add',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/property/add/Index.vue'),
        meta: {title: '属性管理'},
    },
    {
        path: '/baseinfo/property/edit/:id',
        name: 'baseinfo-property-edit',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/property/edit/Index.vue'),
        meta: {title: '属性管理'},
    },
    {
        path: '/baseinfo/filter',
        name: 'baseinfo-filter',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/filter/Index.vue'),
        meta: {title: '过滤项管理'},
    },
    {
        path: '/baseinfo/filter/add',
        name: 'baseinfo-filter-add',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/filter/Add.vue'),
        meta: {title: '过滤项管理'},
    },
    {
        path: '/baseinfo/filter/edit/:id',
        name: 'baseinfo-filter-edit',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/filter/edit/Index.vue'),
        meta: {title: '过滤项管理'},
    },

    // 关键字和字典
    {
        path: '/baseinfo/keyword',
        name: 'baseinfo-keyword',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/keyword/Index.vue'),
        meta: {title: '关键字管理'},
    },
    {
        path: '/baseinfo/keyword/model/:key',
        name: 'baseinfo-keyword-model',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/keyword/Models.vue'),
        meta: {title: '关键字管理'},
    },
    {
        path: '/baseinfo/keyword/material/:key',
        name: 'baseinfo-keyword-material',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/keyword/Materials.vue'),
        meta: {title: '关键字管理'},
    },
    {
        path: '/baseinfo/dictionary',
        name: 'baseinfo-dictionary',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/baseinfo/dictionary/Index.vue'),
        meta: {title: '字典管理'},
    },

    // 公告管理(通知)
    {
        path: '/baseinfo/notice',
        name: 'message-notice',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/notice/Index.vue'),
        meta: {title: '公告管理'},
    },
    {
        path: '/baseinfo/notice/add',
        name: 'message-notice-add',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/notice/Add.vue'),
        meta: {title: '公告管理'},
    },
    {
        path: '/baseinfo/notice/edit/:id',
        name: 'message-notice-edit',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/notice/Edit.vue'),
        meta: {title: '公告管理'},
    },
    {
        path: '/baseinfo/notice/detail/:id',
        name: 'message-notice-detail',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/notice/Detail.vue'),
        meta: {title: '公告管理'},
    },

    // 告知管理(发件方式)
    {
        path: '/baseinfo/sender-config',
        name: 'message-sender',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/sender/Index.vue'),
        meta: {title: '告知管理'},
    },
    {
        path: '/baseinfo/sender-config/add/email',
        name: 'message-sender-add-email',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/sender/AddEmail.vue'),
        meta: {title: '告知管理'},
    },
    {
        path: '/baseinfo/sender-config/edit/email/:id',
        name: 'message-sender-edit-email',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/sender/EditEmail.vue'),
        meta: {title: '告知管理'},
    },
    {
        path: '/baseinfo/sender-config/add/sms',
        name: 'message-sender-add-sms',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/sender/AddSMS.vue'),
        meta: {title: '告知管理'},
    },
    {
        path: '/baseinfo/sender-config/edit/sms/:id',
        name: 'message-sender-edit-sms',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/sender/EditSMS.vue'),
        meta: {title: '告知管理'},
    },

    // 告知模板(消息模板)
    {
        path: '/baseinfo/sender-template',
        name: 'message-template',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/template/Index.vue'),
        meta: {title: '告知模板'},
    },
    {
        path: '/baseinfo/sender-template/add',
        name: 'message-template-add',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/template/Add.vue'),
        meta: {title: '告知模板'},
    },
    {
        path: '/baseinfo/sender-template/edit/:id',
        name: 'message-template-edit',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/template/Edit.vue'),
        meta: {title: '告知模板'},
    },
    {
        path: '/baseinfo/sender-template/detail/:id',
        name: 'message-template-detail',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/template/Detail.vue'),
        meta: {title: '告知模板'},
    },

    // 告知日志(消息日志)
    {
        path: '/baseinfo/sender-log',
        name: 'message-log',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/log/Index.vue'),
        meta: {title: '告知日志'},
    },
    {
        path: '/baseinfo/sender-log/:id',
        name: 'message-log-detail',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/message/log/Detail.vue'),
        meta: {title: '告知日志'},
    },

    // 客户端配置及定时任务
    {
        path: '/baseinfo/client',
        name: 'system-client',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/system/client/Index.vue'),
        meta: {title: '客户端配置'},
    },
    {
        path: '/baseinfo/task-cron',
        name: 'system-task-cron',
        component: () => import(/* webpackChunkName: "baseinfo" */ '@/views/system/cron/Index.vue'),
        meta: {title: '定时任务'},
    },
];
